import { showNotify } from "vendor/application/disptach";

export const validateEquivalences = (variables, dispatch) => {
  const hasInvalid = variables.some((variable) =>
    variable?.zendesk_ticket_field?.equivalences?.some(
      (eq) => !eq.text?.trim() || !eq.value?.trim() || eq.value === "-"
    )
  );

  if (hasInvalid) {
    dispatch(
      showNotify({
        message: "extensions_ticket_field_text_is_required",
        severity: "error",
      })
    );
    return true;
  }

  return false;
};
